interface Column {
  dataField: string;
  text: string;
  sort?: boolean;
}

export function createColumns(...columns: Column[]): Column[] {
  return columns.map((col) => ({
    ...col,
    sort: col.sort !== undefined ? col.sort : true,
  }));
}
